import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { HOME_URL } from "@/lib/constants";
import { isEmbedded } from "@/lib/embed";

export const Header = () => {
  const navigate = useNavigate();

  // In embedded mode (inside an iframe on rendeavored.com, or ?embedded=1),
  // hide the app's internal header/navigation entirely so the parent site's
  // header is the only one shown. Returning null on the first render avoids
  // any flash of the header.
  if (isEmbedded()) return null;

  return (
    <header
      className="sticky top-0 z-40 border-b border-white/10 backdrop-blur"
      style={{ backgroundColor: "rgba(10,10,11,0.92)" }}
      data-testid="site-header"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        {/* Logo -> main public website (same tab) */}
        <a href={HOME_URL} data-testid="header-logo-link" className="flex items-center">
          <Logo height={30} />
        </a>
        <nav className="flex items-center gap-2 sm:gap-3">
          <a
            href={HOME_URL}
            className="hidden sm:inline text-sm text-white/70 hover:text-white px-3 py-2 transition-colors"
            data-testid="nav-home"
          >
            Home
          </a>
          <a
            href="/#how-it-works"
            className="hidden sm:inline text-sm text-white/70 hover:text-white px-3 py-2 transition-colors"
            data-testid="nav-how-it-works"
          >
            How it works
          </a>
          <a
            href="/admin"
            className="hidden sm:inline text-sm text-white/70 hover:text-white px-3 py-2 transition-colors"
            data-testid="nav-admin"
          >
            Admin
          </a>
          <Button
            data-testid="header-start-assessment-button"
            onClick={() => navigate("/assessment")}
            className="bg-[#1E6BFF] hover:bg-[#3B82F6] text-white rounded-xl"
          >
            Start Assessment
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
